import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

/**
 * Same as `Validators.email`, but ignores leading/trailing whitespace.
 *
 * The native login flow trims the username before sending it to Cognito, so a stray
 * space around an otherwise valid email must not block the form from submitting.
 * Empty values are treated as valid, exactly like `Validators.email`.
 */
export const trimmedEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (typeof value !== 'string') {
        return Validators.email(control);
    }
    return Validators.email(new FormControl(value.trim()));
};
